export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const apiCall = async (endpoint: string, options: RequestInit = {}) => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error en API:', error);
    throw error;
  }
};

export * from './helpers';
